export enum AppRouteEnum {
  AchRefundTable = '/reports/ach-refunds',
  Auth = '/auth',
  CancelPendings = '/reports/cancel-pendings',
  CancelRewrites = '/reports/cancel-rewrites',
  ConsumerEdit = '/consumers/:id/edit',
  ConsumerProfile = '/consumers/:id',
  ConsumerWrapUp = '/consumers/:id/wrap-up',
  Consumers = '/consumers',
  ConsumerHome = '/consumers/:id/homes/:id',
  ConsumerVehicle = '/consumers/:id/vehicles/:id',
  ContractById = '/contracts/:id',
  ContractByNumber = '/contracts/by-number/:id',
  ContractFulfillmentHistory = '/contracts/:id/fulfillment-history',
  ContactConfirmation = '/contacts/confirmation',
  ContactEcommerceCallback = '/contacts/ecommerce-callback',
  ContactExternalTransfer = '/contacts/external-transfer',
  ContactLink = '/contacts/link',
  ContactPreview = '/contacts/preview',
  ContactSearchAuto = '/contacts/search/auto',
  ContactSearchMail = '/contacts/search/mail',
  ContactSearchMoxyCustomerNumber = '/contacts/search/moxy-customer-number',
  ContactWaiting = '/contacts/waiting',
  ContactWrapUp = '/contacts/:id/wrap-up',
  ContractsAdjustmentAdjustCoverage = '/contracts/:id/adjustment/adjust-coverage',
  ContractsAdjustmentAdditionalActions = '/contracts/:id/adjustment/additional-actions',
  ContractsAdjustmentConfirmAdjustment = '/contracts/:id/adjustment/confirm-adjustment',
  ContractsAdjustmentConfirmOdometer = '/contracts/:id/adjustment/confirm-odometer',
  ContractCollectDownPayment = '/contracts/:id/collect-down-payment/',
  ContractPayInFullOnSold = '/contracts/:id/pay-in-full/',
  ContractCollectExceptionPayment = '/contracts/:id/exception-payment/',
  ContractTransmittalEventsErrorReport = '/reports/contract-transmittal-events-errors',
  Dashboard = '/dashboard',
  DealLog = '/deal-log',
  PostDateDeclines = '/reports/post-date-declines',
  DuplicateSaves = '/reports/duplicate-saves',
  Forbidden = '/forbidden',
  FundedFullRefunds = '/reports/funded-full-refunds',
  // Home = '/dashboard',
  HomeQuoteFlowEntry = '/home-quotes/:id',
  HomeQuoteFlowHomeDetails = '/home-quotes/:id/home-details',
  HomeQuoteFlowSelectCoverage = '/home-quotes/:id/select-coverage',
  HomeQuoteFlowContactInfo = '/home-quotes/:id/contact-info',
  HomeQuoteFlowSecondHolder = '/home-quotes/:id/second-holder',
  HomeQuoteFlowPaymentDetails = '/home-quotes/:id/payment-details',
  HomeQuoteFlowFinalize = '/home-quotes/:id/finalize',
  HomeQuoteFlowSaleComplete = '/home-quotes/:id/sold',
  HomeQuoteFlowWrapUp = '/home-quotes/:id/wrap-up',
  HomeQuoteFlowRecap = '/home-quotes/:id/recap',
  HomeQuoteFlowTransferCall = '/home-quotes/:id/transfer-call',
  HomeQuoteFlowCoverageAvailability = '/home-quotes/:id/coverage-availability',
  HomeContractAdjustmentAdjustCoverage = '/home-contracts/:id/adjustment/adjust-coverage',
  HomeContractWrapUp = '/home-contracts/:id/wrap-up',
  InProgressFulfillments = '/reports/in-progress-fulfillments',
  InitialFulfillments = '/reports/initial-fulfillments',
  KnowledgeBase = '/knowledge-base',
  NewHomeQuote = '/home-quotes/new',
  NewQuote = '/quotes/new',
  Quotes = '/quotes',
  QuoteFlowContactInfo = '/quotes/:id/contact-info',
  QuoteFlowCoverageAvailability = '/quotes/:id/coverage-availability',
  QuoteFlowEntry = '/quotes/:id',
  QuoteFlowFinalize = '/quotes/:id/finalize',
  QuoteFlowMissingVehicleDetails = '/quotes/:id/missing-vehicle-details',
  QuoteFlowPaymentMethod = '/quotes/:id/payment-method',
  QuoteFlowPayments = '/quotes/:id/payments',
  QuoteFlowSecondHolder = '/quotes/:id/second-holder',
  QuoteFlowSelectPlan = '/quotes/:id/select-plan',
  QuoteFlowVehicleDetails = '/quotes/:id/vehicle-details',
  QuoteFlowVehicleModifications = '/quotes/:id/vehicle-modifications',
  QuoteFlowClosed = '/quotes/:id/closed',
  QuoteFlowSaleComplete = '/quotes/:id/sold',
  QuoteFlowWrapUp = '/quotes/:id/wrap-up',
  QuoteScratchpad = '/quote-scratchpad',
  SendQuote = '/quotes/:id/send-quote',
  QuoteFlowTransferCall = '/quotes/:id/transfer-call',
  QuoteFlowRecap = '/quotes/:id/recap',
  QuoteFlowEquityCalculation = '/quotes/:id/equity',
  QuoteFlowCompleteRewrite = '/quotes/:id/complete-rewrite',
  QuoteFlowConfirmRewrite = '/quotes/:id/confirm-rewrite',
  V2QuoteFlowEntry = '/v2/quotes/:id',
  V2HomeQuoteEntry = '/v2/quotes/home/:id',
  V2ConsumerQuoteFlowEntry = '/v2/consumers/:id/quotes/vehicle/:id',
  V2NewQuote = '/v2/consumers/:id/quotes/vehicle/new',
  V2QuoteFlowClosed = '/v2/consumers/:id/quotes/vehicle/:id/closed',
  V2QuoteFlowCompleteRewrite = '/v2/consumers/:id/quotes/vehicle/:id/complete-rewrite',
  V2QuoteFlowConfirmRewrite = '/v2/consumers/:id/quotes/vehicle/:id/confirm-rewrite',
  V2QuoteFlowContactInfo = '/v2/consumers/:id/quotes/vehicle/:id/contact-info',
  V2QuoteFlowCoverageAvailability = '/v2/consumers/:id/quotes/vehicle/:id/coverage-availability',
  V2QuoteFlowEquity = '/v2/consumers/:id/quotes/vehicle/:id/equity',
  V2QuoteFlowFinalize = '/v2/consumers/:id/quotes/vehicle/:id/finalize',
  V2QuoteFlowMissingVehicleDetails = '/v2/consumers/:id/quotes/vehicle/:id/missing-vehicle-details',
  V2QuoteFlowPaymentMethod = '/v2/consumers/:id/quotes/vehicle/:id/payment-method',
  V2QuoteFlowPayments = '/v2/consumers/:id/quotes/vehicle/:id/payments',
  V2QuoteFlowRecap = '/v2/consumers/:id/quotes/vehicle/:id/recap',
  V2QuoteFlowSaleComplete = '/v2/consumers/:id/quotes/vehicle/:id/sold',
  V2QuoteFlowSecondHolder = '/v2/consumers/:id/quotes/vehicle/:id/second-holder',
  V2QuoteFlowSelectPlan = '/v2/consumers/:id/quotes/vehicle/:id/select-plan',
  V2QuoteFlowSendQuote = '/v2/consumers/:id/quotes/vehicle/:id/send-quote',
  V2QuoteFlowTransferCall = '/v2/consumers/:id/quotes/vehicle/:id/transfer-call',
  V2QuoteFlowVehicleDetails = '/v2/consumers/:id/quotes/vehicle/:id/vehicle-details',
  V2QuoteFlowVehicleModifications = '/v2/consumers/:id/quotes/vehicle/:id/vehicle-modifications',
  V2QuoteFlowWrapUp = '/v2/consumers/:id/quotes/vehicle/:id/wrap-up',
  V2HomeQuoteFlowEntry = '/v2/consumers/:id/quotes/home/:id',
  V2NewHomeQuote = '/v2/consumers/:id/quotes/home/new',
  V2HomeQuoteFlowContactInfo = '/v2/consumers/:id/quotes/home/:id/contact-info',
  V2HomeQuoteFlowCoverageAvailability = '/v2/consumers/:id/quotes/home/:id/coverage-availability',
  V2HomeQuoteFlowFinalize = '/v2/consumers/:id/quotes/home/:id/finalize',
  V2HomeQuoteFlowHomeDetails = '/v2/consumers/:id/quotes/home/:id/home-details',
  V2HomeQuoteFlowPaymentDetails = '/v2/consumers/:id/quotes/home/:id/payment-details',
  V2HomeQuoteFlowRecap = '/v2/consumers/:id/quotes/home/:id/recap',
  V2HomeQuoteFlowSaleComplete = '/v2/consumers/:id/quotes/home/:id/sold',
  V2HomeQuoteFlowSecondHolder = '/v2/consumers/:id/quotes/home/:id/second-holder',
  V2HomeQuoteFlowSelectCoverage = '/v2/consumers/:id/quotes/home/:id/select-coverage',
  V2HomeQuoteFlowTransferCall = '/v2/consumers/:id/quotes/home/:id/transfer-call',
  V2HomeQuoteFlowWrapUp = '/v2/consumers/:id/quotes/home/:id/wrap-up',
  V2ContactExternalTransfer = '/v2/contacts/external-transfer',
  V2ContactPreview = '/v2/contacts/preview',
  V2ContactSearchAuto = '/v2/contacts/search/auto',
  V2ContactSearchMail = '/v2/contacts/search/mail',
  V2ContactSearchMoxyCustomerNumber = '/v2/contacts/search/moxy-customer-number',
  V2ContractById = '/v2/contracts/:id',
  V2VehicleContract = '/v2/consumers/:id/vehicles/:id/contracts/:id',
  V2VehicleSalePendingProcessAchRefunds = '/v2/consumers/:id/vehicles/:id/sale-pending/:id/process-ach-refunds',
  V2HomeContract = '/v2/consumers/:id/homes/:id/contracts/:id',
  Settings = '/settings',
  Users = '/users',
  PhysicalChecks = '/reports/physical-checks',
  ProcessContractManualRefund = '/contracts/:id/process-ach-refunds',
  ProcessSalePendingManualRefund = '/sale-pending/:id/process-ach-refunds',
  Roles = '/roles',
  VehicleDetails = '/vehicles/:id',
  VehicleShops = '/vehicle-shops/:id',
  Waiting = '/contacts/waiting/:id',
  CancelFlat = '/contracts/:id/cancel/flat',
  RequestCancellation = '/contracts/:id/cancel/request-cancellation',
  CompleteCancellation = '/contracts/:id/cancel/complete-cancellation',
  ProRatedRefund = '/contracts/:id/cancel/pro-rated-refund',
  CalculateProRatedRefund = '/contracts/:id/cancel/calculate-pro-rated-refund',
  RemoveCancelPending = '/contracts/:id/cancel/remove-cancel-pending',
  CancelNonPay = '/contracts/:id/cancel/non-pay',
  TransferContractUploadTransferForm = '/contracts/:id/transfer/upload-transfer-form',
  TransferContractSelectCustomer = '/contracts/:id/transfer/select-customer',
  TransferContractCollectMissingInfo = '/contracts/:id/transfer/collect-missing-info',
  TransferContractAdditionalHolder = '/contracts/:id/transfer/additional-holder',
  TransferContractPayments = '/contracts/:id/transfer/payments',
  TransferOwnerships = '/reports/transfer-ownerships-eds',
  NonEdsTransferOwnerships = '/reports/transfer-ownerships-non-eds',
  RetentionDiscounts = '/reports/retention-discounts',
  ContractWrapUp = '/contracts/:id/wrap-up',
  AdditionalRefund = '/contracts/:id/additional-refund',
  FullRefundManagerApproval = '/contracts/:id/full-refund/manager-approval',
  FullRefundCreateRequest = '/contracts/:id/full-refund/create-refund',
  FullRefundApproveRefund = '/contracts/:id/cancel/approve-full-refund',
  FullRefundIssueRefund = '/contracts/:id/cancel/issue-full-refund',
  VinAudit = '/vin-audit',
  MissingDownPayment = '/reports/missing-down-payment',
  ProRatedRefundsReport = '/reports/pro-rated-refund',
  CollectionReporting = '/contracts/:id/collection-reporting',
  CarfaxReports = '/reports/carfax/:id',
  V2ConsumerEdit = '/v2/consumers/:id/edit',
  V2ConsumerProfile = '/v2/consumers/:id',
  V2Dashboard = '/v2/dashboard',
  V2DealLog = '/v2/deal-log',
  V2Reports = '/v2/reports',
  V2ReportsAchRefunds = '/v2/reports/ach-refunds',
  V2ReportsCancelPendings = '/v2/reports/cancel-pendings',
  V2ReportsCancelRewrites = '/v2/reports/cancel-rewrites',
  V2ReportsCarfax = '/v2/reports/carfax/:id',
  V2ReportsContractTransmittalEventsErrors = '/v2/reports/contract-transmittal-events-errors',
  V2ReportsDuplicateSaves = '/v2/reports/duplicate-saves',
  V2ReportsFundedFullRefunds = '/v2/reports/funded-full-refunds',
  V2ReportsInProgressFulfillments = '/v2/reports/in-progress-fulfillments',
  V2ReportsMissingDownPayment = '/v2/reports/missing-down-payment',
  V2ReportsNonEdsTransferOwnerships = '/v2/reports/transfer-ownerships-non-eds',
  V2ReportsPhysicalChecks = '/v2/reports/physical-checks',
  V2ReportsPostDateDeclines = '/v2/reports/post-date-declines',
  V2ReportsProRatedRefund = '/v2/reports/pro-rated-refund',
  V2ReportsRetentionDiscounts = '/v2/reports/retention-discounts',
  V2ReportsTransferOwnerships = '/v2/reports/transfer-ownerships-eds',
  V2Roles = '/v2/roles',
  V2Users = '/v2/users',
  V2VinAudit = '/v2/vin-audit',
}
